import { baseSiteEndPoint, buildHeaders, urlFilters } from "./common";
import { authorizedFetch } from "./login";

/**
 * Fetch daily account snapshots
 * @param {Object} filters - Query parameters (date_gte, date_lte)
 * @returns {Promise} API response with total_accounts data
 */
export const apiAccountSnapshots = async (filters = {}) => {
  const response = await authorizedFetch(
    urlFilters(`${baseSiteEndPoint}/unified/statistics/snapshots/`, filters),
    {
      method: "GET",
      headers: buildHeaders(),
    }
  );
  const data = await response.json();
  return data;
};

/**
 * Fetch daily transaction counts
 * @param {Object} filters - Query parameters (date_gte, date_lte)
 * @returns {Promise} API response with transaction metrics
 */
export const apiDailyTransactions = async (filters = {}) => {
  const response = await authorizedFetch(
    urlFilters(`${baseSiteEndPoint}/unified/statistics/transactions/`, filters),
    {
      method: "GET",
      headers: buildHeaders(),
    }
  );
  const data = await response.json();
  return data;
};

/**
 * Fetch accounts by type
 * @param {Object} filters - Query parameters (date_gte, date_lte, account_type)
 * @returns {Promise} API response with accounts segmented by type
 */
export const apiAccountsByType = async (filters = {}) => {
  const response = await authorizedFetch(
    urlFilters(`${baseSiteEndPoint}/unified/statistics/by-type/`, filters),
    {
      method: "GET",
      headers: buildHeaders(),
    }
  );
  const data = await response.json();
  return data;
};

/**
 * Fetch accounts by MCC
 * @param {Object} filters - Query parameters (date_gte, date_lte, mcc)
 * @returns {Promise} API response with accounts segmented by MCC
 */
export const apiAccountsByMcc = async (filters = {}) => {
  const response = await authorizedFetch(
    urlFilters(`${baseSiteEndPoint}/unified/statistics/by-mcc/`, filters),
    {
      method: "GET",
      headers: buildHeaders(),
    }
  );
  const data = await response.json();
  return data;
};

/**
 * Fetch accounts by category
 * @param {Object} filters - Query parameters (date_gte, date_lte, category)
 * @returns {Promise} API response with accounts segmented by category
 */
export const apiAccountsByCategory = async (filters = {}) => {
  const response = await authorizedFetch(
    urlFilters(`${baseSiteEndPoint}/unified/statistics/by-category/`, filters),
    {
      method: "GET",
      headers: buildHeaders(),
    }
  );
  const data = await response.json();
  return data;
};

/**
 * Fetch accounts by split plan
 * @param {Object} filters - Query parameters (date_gte, date_lte, split_plan, split_plan_name)
 * @returns {Promise} API response with accounts segmented by split plan
 */
export const apiAccountsBySplitPlan = async (filters = {}) => {
  const response = await authorizedFetch(
    urlFilters(`${baseSiteEndPoint}/unified/statistics/by-split-plan/`, filters),
    {
      method: "GET",
      headers: buildHeaders(),
    }
  );
  const data = await response.json();
  return data;
};

/**
 * Fetch accounts by distributor N1
 * @param {Object} filters - Query parameters (date_gte, date_lte, distributor, distributor_name)
 * @returns {Promise} API response with accounts segmented by N1 distributor
 */
export const apiAccountsByDistributorN1 = async (filters = {}) => {
  const response = await authorizedFetch(
    urlFilters(`${baseSiteEndPoint}/unified/statistics/by-distributor-n1/`, filters),
    {
      method: "GET",
      headers: buildHeaders(),
    }
  );
  const data = await response.json();
  return data;
};

/**
 * Fetch accounts by distributor N2
 * @param {Object} filters - Query parameters (date_gte, date_lte, distributor, distributor_name)
 * @returns {Promise} API response with accounts segmented by N2 distributor
 */
export const apiAccountsByDistributorN2 = async (filters = {}) => {
  const response = await authorizedFetch(
    urlFilters(`${baseSiteEndPoint}/unified/statistics/by-distributor-n2/`, filters),
    {
      method: "GET",
      headers: buildHeaders(),
    }
  );
  const data = await response.json();
  return data;
};

/**
 * Fetch accounts by agent
 * @param {Object} filters - Query parameters (date_gte, date_lte, agent, agent_name)
 * @returns {Promise} API response with accounts segmented by agent
 */
export const apiAccountsByAgent = async (filters = {}) => {
  const response = await authorizedFetch(
    urlFilters(`${baseSiteEndPoint}/unified/statistics/by-agent/`, filters),
    {
      method: "GET",
      headers: buildHeaders(),
    }
  );
  const data = await response.json();
  return data;
};
